import AudioRecorder from 'audio-recorder-polyfill'
(window as any).MediaRecorder = AudioRecorder
